import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    boxShadow: 'none',
    '&:before': {
      height: 0,
    },
  },
  description: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'left',
  },
  model: {
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  brand: {
    fontSize: 12,
    fontWeight: 400,
    textTransform: 'uppercase',
    color: '#9DA5B1',
  },
  table: {
    width: '100%',
  },
  cell: {
    borderBottom: 'none',
  },
}));
